import { removeNulls } from "../form_helpers";

export function getDevicesInLocale(itemType, regionId, buildingId, areaId, roomId, projectScopeToken) {
    const results = [];
    let pagination_token = null;

    const execute_query = async PaginationToken => {
        if (PaginationToken) {
            pagination_token = PaginationToken;
        }

        // Issue the request
        return $.ajax({
            url: '/api/items/list',
            dataType: 'json',
            method: 'GET',
            // Only attached when a token was actually supplied -- e.g. the Reports page, which
            // needs devices across every Project the user can see, not just the active one. See
            // shared/locales/locales.js for the same pattern applied to the locale endpoints.
            headers: projectScopeToken ? { 'X-Project-Scope-Token': projectScopeToken } : {},
            data: removeNulls({
                type: itemType,
                region: regionId,
                building: buildingId,
                area: areaId,
                room: roomId,
                pagination_token: pagination_token
            })
        }).promise().then(devices_json => {
            // Gather the results from this query and stash them in the output object
            for (const index in devices_json.data.items) {
                results.push(devices_json.data.items[index]);
            }

            // Break out of this recursive loop if we've found everything
            if (devices_json.data.pagination_token === null) {
                return results;
            }

            // If we haven't found everything, recurse again with the updated pagination token
            return execute_query(devices_json.data.pagination_token);
        }).catch(error => {
            console.error(error);
            throw new Error('Error fetching manufacturers. Please try again.');
        });
    };

    return execute_query();
}

export function getDevicesInBundleInstance(bundleId, bundleInstanceId) {
    const results = [];
    let pagination_token = null;

    const execute_query = async PaginationToken => {
        if (PaginationToken) {
            pagination_token = PaginationToken;
        }

        // Issue the request to get all items in the bundle instance
        return $.ajax({
            url: '/api/items/list',
            dataType: 'json',
            method: 'GET',
            data: removeNulls({
                type: 'bundle_instances',
                bundle_id: bundleId,
                bundle_instance_id: bundleInstanceId,
                pagination_token: pagination_token
            })
        }).promise().then(items_json => {
            // Gather the results from this query and stash them in the output object
            for (const index in items_json.data.items) {
                results.push(items_json.data.items[index]);
            }

            // Break out of this recursive loop if we've found everything
            if (items_json.data.pagination_token === null) {
                return results;
            }

            // If we haven't found everything, recurse again with the updated pagination token
            return execute_query(items_json.data.pagination_token);
        }).catch(error => {
            console.error(error);
            throw new Error('Error fetching bundle instance items. Please try again.');
        });
    };

    return execute_query();
}